import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    UpdateProductBrandInput,
    CreateProductBrandInput,
    ProductBrand
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ProductBrandService {
    private amplifyClient = generateClient();

    constructor() {}

    async getProductBrand(id: string): Promise<ProductBrand> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getProductBrand,
                    variables: {
                        id
                    }
                })
            ).data.getProductBrand;
            if (data) return data as ProductBrand;
        } catch (error) {
            console.error('Error finding ProductBrand:', error);
            return null;
        }
    }

    async listProductBrands(): Promise<ProductBrand[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listProductBrands
                })
            ).data.listProductBrands.items;
            if (data) return data as ProductBrand[];
        } catch (error) {
            console.error('Error finding ProductBrands:', error);
            return null;
        }
    }

    async createProductBrand(
        input: CreateProductBrandInput
    ): Promise<ProductBrand> {
        try {
            const productDimention = (
                await this.amplifyClient.graphql({
                    query: mutations.createProductBrand,
                    variables: {
                        input
                    }
                })
            ).data.createProductBrand;
            if (productDimention) return productDimention as ProductBrand;
        } catch (error) {
            console.error('Error creating ProductBrand:', error);
            return null;
        }
    }

    async updateProductBrand(
        input: UpdateProductBrandInput
    ): Promise<ProductBrand> {
        try {
            const productBrand = (
                await this.amplifyClient.graphql({
                    query: mutations.updateProductBrand,
                    variables: {
                        input
                    }
                })
            ).data.updateProductBrand;
            if (productBrand) return productBrand as ProductBrand;
        } catch (error) {
            console.error('Error updating productBrand:', error);
            return null;
        }
    }
}
